import { render } from "./AdminMessages.vue?vue&type=template&id=4d48b630"
import script from "./AdminMessages.vue?vue&type=script&lang=js"
export * from "./AdminMessages.vue?vue&type=script&lang=js"

import "./AdminMessages.vue?vue&type=style&index=0&id=4d48b630&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__